import React from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../../asset/navbar/logo.svg";

function NavbarNew({ toggleSidebarNew, isSidebarCrossOpenNew }) {
    return (
      <div
        style={{
          height: "40px",
          display: "flex",
          alignItems: "center",
          padding: "0 16px",
          backgroundColor: "transparent",
           justifyContent:'space-between',
        }}
      >
        <button
          onClick={toggleSidebarNew}
          style={{
            background: "none",
            border: "none",
            color: "black",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            padding: "8px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.1)"}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}
        >
          {isSidebarCrossOpenNew ? <FaTimes size={18} /> : <FaBars size={18} />}
        </button>
        <img style={{
    width: '125px', // Adjusted width to match the image proportion
    height: 'auto',
    marginTop:5, // Allow height to scale with the image
    // background-color: #ffffff; // White background strip as seen in the image
    // padding: '5px 10px', // Add padding to create the strip effect
    // borderRadius: '4px', // Slight rounding to match the subtle curve
    // display: 'inline-block', // Ensure it centers properly
    // backgroundColor: '#044585'
  }}  src={logo} alt="jobizo-logo" />

      </div>
    );
}

export default NavbarNew;
